import { z } from 'zod';

export const profileParamsSchema = z.object({
    tab: z
        .enum(['completed', 'created', 'packs'])
        .default('completed')
        .catch('completed'),
    breakdown: z.enum(['tags', 'nlw']).default('tags').catch('tags'),
});

export const defaultProfileSearchParams = profileParamsSchema.parse({});

export type profileParamsType = z.infer<typeof profileParamsSchema>;
